<template>
  <div class="video-content">
    <div class="video-list">
      <h3>Directory</h3>
      <ol>
        <li :class="getClass('EasyFlyTracker_screen1')" @click="gotoVideo('EasyFlyTracker_screen1')">How to modify the config.yaml file.</li>
        <li :class="getClass('EasyFlyTracker_screen2')" @click="gotoVideo('EasyFlyTracker_screen2')">Execute the command to track and then configure.</li>
        <li :class="getClass('EasyFlyTracker_screen3')" @click="gotoVideo('EasyFlyTracker_screen3')">Finish numbering flies and start tracking.</li>
        <li :class="getClass('EasyFlyTracker_screen4')" @click="gotoVideo('EasyFlyTracker_screen4')">Watch the process of tracking.</li>
        <li :class="getClass('EasyFlyTracker_screen5')" @click="gotoVideo('EasyFlyTracker_screen5')">Display the results of tracking.</li>
        <li :class="getClass('EasyFlyTracker_screen6')" @click="gotoVideo('EasyFlyTracker_screen6')">Analyze and statistic tracking information.</li>
      </ol>
    </div>

    <div class="video-detail">
      <video-player class="video-player vjs-custom-skin"
                    style="width: 100%;height: 100%"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="videoOptions">
      </video-player>
    </div>
  </div>
</template>

<script>
export default {
  name: "videoList",
  data :function (){
    return{
      isCollapsed : false,
      name : "",
    }
  },
  beforeMount() {
    this.name = this.$route.query.videoName;
  },
  methods : {
    gotoVideo : function (flag){
      this.$router.push({
        path : "/videoList",
        query : {
          videoName : flag
        }
      })
    },
    getClass(flag){
      if (this.name === flag){
        return "selected"
      }
      return ""
    }
  },
  watch : {
    videoName(val){
      this.name = val;
    }
  },
  computed: {
    videoName: function () {
      return this.$route.query.videoName;
    },
    menuitemClasses: function () {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    },
    videoOptions : function (){
      return{
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: this.$axios.defaults.baseURL + "/video/" + this.videoName + ".mp4" // url地址
        }],
        poster: "", // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      }
    }
  }
}
</script>

<style scoped>
.video-content{
  width: 100%;
  height: 100vh;
  padding: 10px 10px;
  background-color: #1d1d1d;
  color: #999;
  overflow-y: auto;
}
li{
  cursor: pointer;
  margin-top: 10px;
}
.video-list{
  display: inline-block;
  width: 20%;
  height: 100%;
  padding: 20px 20px;

}
.selected{
  color: #42b983;
}
.video-detail{
  display: inline-block;
  width: 75%;
  margin-top: 50px;
  vertical-align: top;
}

</style>